import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import WizardPaso2 from '../components/WizardPaso6';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import { createAgendamiento, nuevoPaciente } from '../services/api/authService';
import { FaMapMarkerAlt } from 'react-icons/fa';

const ConfirmaAgendamiento = () => {
  useEffect(() => {
    setPasoActual("ConfirmaAgendamiento");
  
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "paso_confirma_agendamiento" });
  
    setUltimoEventoGTM("paso_confirma_agendamiento");
  }, []);
  
  const navigate = useNavigate();
  const { contextData, setPasoActual, setUltimoEventoGTM, sessionId, utmData, registrarEventoVisual } = useAppAgendaContext();
  const [agendamiento, setAgendamiento] = useState(null);

  const logEvento = async ({ paso, evento, descripcion, campo, valor }) => {
    const payload = {
      session_id: sessionId,
      paso,
      evento,
      descripcion,
      campo_afectado: campo || null,
      valor_ingresado: valor || null,
      fecha_evento: new Date().toISOString(),
      ...utmData,
      origen_referrer: document.referrer || null
    };

    /*try {
      await fetch('/api/agendamiento/evento', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      console.error("Error enviando evento:", error);
    }*/
  };

  useEffect(() => {
    const agendamientoRealizado = sessionStorage.getItem('agendamientoRealizado');
    if (agendamientoRealizado === 'true') return;

    const enviarAgendamiento = async () => {
      const { pacienteEstado, pacRut, pacDv, pacNombre, pacCorreo, pacTelefono } = contextData;

      const nombreSeparado = pacNombre ? pacNombre.split(' ') : [];
      const pacNombrePart1 = nombreSeparado[0] || '';
      const pacApellidoPat = nombreSeparado[1] || '';
      const pacApellidoMat = nombreSeparado.slice(2).join(' ') || '';

      if (pacienteEstado === 'Web2_p') {
        if (!pacRut || !pacDv || !pacNombrePart1 || !pacApellidoPat || !pacCorreo || !pacTelefono) return;
        try {
          await nuevoPaciente({
            pacRut,
            pacDv,
            pacNombre: pacNombrePart1,
            pacApellidoPat,
            pacApellidoMat,
            pacCorreo,
            pacMovil: pacTelefono,
          });
        } catch (error) {
          return;
        }
      }

      try {
        const agendamientoData = {
          horId: contextData.horId,
          ageFecha: contextData.ageFecha,
          ageHora: contextData.ageHora,
          ageHoraFin: contextData.ageHoraFin,
          pacRut: contextData.pacRut,
          ageBloques: 2,
          tiphoId: contextData.tiphoId,
          ageNotas: '',
          sillID: contextData.sillID,
          odontRut: contextData.odontRut,
          agendaRut: '',
        };

        const response = await createAgendamiento(agendamientoData);
        sessionStorage.setItem('agendamientoRealizado', 'true');
        setAgendamiento(response.data);

        registrarEventoVisual({
          paso: 'ConfirmaAgendamiento',
          evento: 'agendamiento_exitoso',
          descripcion: `Agendamiento confirmado para ${contextData.ageFecha} ${contextData.ageHora}`
        });

        logEvento({
          paso: 'ConfirmaAgendamiento',
          evento: 'agendamiento_exitoso',
          descripcion: 'Agendamiento fue registrado exitosamente en la base de datos'
        });

        try {
          const response = await fetch('https://confirmahora.morapavic.cl/confirmar-hora/send-mail.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              token: '123abcSECRET',
              to_email: contextData.pacCorreo,
              to_name: contextData.pacNombre,
              subject: 'Confirmación de tu hora en Clínica Mora Pavic',
              fecha: contextData.ageFecha,
              hora: contextData.ageHora,
              doctor: contextData.doctorName,
              sucursal: contextData.sucursalNombre,
              direccion: contextData.sucursalDireccion,
              mapa_url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contextData.sucursalDireccion || '')}`
            })
          });
        
          const result = await response.json();

          if (result.success) {
            registrarEventoVisual({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_enviado',
              descripcion: `Correo enviado a ${contextData.pacCorreo}`
            });

            logEvento({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_enviado',
              descripcion: 'Se envió correctamente el correo de confirmación',
              campo: 'email',
              valor: contextData.pacCorreo
            });
          } else {
            registrarEventoVisual({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_error',
              descripcion: 'Error al enviar el correo de confirmación'
            });

            logEvento({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_error',
              descripcion: 'Fallo el envío del correo de confirmación',
              campo: 'email',
              valor: contextData.pacCorreo
            });
          }
        
          if (!response.ok || !result.success) {
            console.error("Error al enviar correo electrónico:", result);
          }
        } catch (error) {
          console.error("Error en fetch de envío de correo:", error);
        }
        
      } catch (error) {
        alert('Hubo un problema al confirmar tu agendamiento. Intenta nuevamente.');
      }
    };

    enviarAgendamiento();
  }, [contextData, navigate]);

  // useEffect para redirigir automáticamente a IndexPac y Cerrar sesión después de 10 segundos
  useEffect(() => {
    const timeout = setTimeout(() => {
      sessionStorage.clear();
      navigate('/IndexPac', { replace: true });
    }, 10000); // 10 segundos

    return () => clearTimeout(timeout);
  }, [navigate]);

  const handleNoGracias = () => {
    sessionStorage.clear();
    navigate('/IndexPac');
  };

  return (
    <Container>
      <WizardPaso2 />
      <Content>
        <Title>Tu hora fue <strong>AGENDADA</strong> con éxito!</Title>

        <ResumenWrapper>
          <ResumenCard>
            <CardTitle>
              <img src="/images/ico_usuario.png" alt="icono usuario" style={{ width: "30px", marginRight: "10px" }} />
              Datos del Paciente
            </CardTitle>
            <Item><strong>Nombre:</strong> {contextData.pacNombre || 'Sin nombre'}</Item>
            <Item><strong>RUT:</strong> {contextData.pacRut || '---'}</Item>
            <Item><strong>Teléfono:</strong> {contextData.pacTelefono || '---'}</Item>
            <Item><strong>Correo:</strong> {contextData.pacCorreo || '---'}</Item>
          </ResumenCard>

          <ResumenCard>
            <CardTitle>
              <img src="/images/ico_atencion.png" alt="icono atención" style={{ width: "30px", marginRight: "10px" }} />
              Información de la Atención
            </CardTitle>
            <Item><strong></strong> {contextData.doctorName || 'Sin información'}</Item>
            <Item><strong>Tipo de Atención:</strong> Evaluación Dental</Item>
            <Item><strong>Fecha:</strong> {contextData.ageFecha
              ? (() => {
                  const [year, month, day] = contextData.ageFecha.split("-");
                  const parsedDate = new Date(`${year}-${month}-${day}T00:00:00`);
                  return parsedDate.toLocaleDateString('es-ES', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  });
                })()
              : 'Sin fecha'}
            </Item>
            <Item><strong>Hora:</strong> {contextData.ageHora || '---'}</Item>
            <Item><strong>Sucursal:</strong> {contextData.sucursalNombre || '---'}</Item>
          </ResumenCard>
        </ResumenWrapper>

        <MensajeImportante>
          <strong>Recuerde:</strong> Las radiografías tienen costo. Consulte en clínica.
        </MensajeImportante>

        {contextData.sucursalDireccion && (
          <DireccionBox>
            <strong>Dirección:</strong> {contextData.sucursalDireccion}
            <LocationContainer>
              <LocationIcon />
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contextData.sucursalDireccion)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                (Abrir en Google Maps)
              </a>
            </LocationContainer>
          </DireccionBox>
        )}

        <ButtonGroup style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkmark>
            <i className="fas fa-check-circle" style={{ fontSize: '30px', color: '#00c2a8' }}></i>
          </Checkmark>
          <Button type="button" secondary onClick={handleNoGracias}>
            Finalizar
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const Content = styled.div`
  padding: 20px;
  text-align: center;
`;

const Title = styled.h3`
  color: #00608a;
  margin-bottom: 30px;
`;

const ResumenWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const ResumenCard = styled.div`
  flex: 1;
  min-width: 280px;
  background-color: #f0f8fa;
  border-radius: 10px;
  padding: 20px;
  text-align: left;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;

const CardTitle = styled.h4`
  color: #00cfd4;
  font-size: 18px;
  margin-bottom: 15px;
`;

const Item = styled.p`
  margin: 8px 0;
  font-size: 16px;
`;

const Checkmark = styled.div`
  margin: 30px 0;
  font-size: 40px;
  color: #00cfd4;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: ${props => props.secondary ? '#fff' : '#00cfd4'};
  border: ${props => props.secondary ? '1px solid #6c757d' : 'none'};
  border-radius: 20px;
  color: ${props => props.secondary ? '#6c757d' : '#fff'};
  cursor: pointer;
  font-size: 16px;
  padding: 10px 20px;
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.secondary ? '#f8f9fa' : '#00bfc4'};
  }
`;

const DireccionBox = styled.div`
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
  padding: 14px;
  margin-top: 30px;
  border-radius: 8px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;

  strong {
    color: #00547F;
  }

  a {
    color: #007bff;
    text-decoration: underline;
    margin-left: 5px;
  }
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  gap: 5px;
`;

const LocationIcon = styled(FaMapMarkerAlt)`
  color: #00BEB8;
  font-size: 18px;
`;

const MensajeImportante = styled.div`
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 15px 20px;
  margin-top: 20px;
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  text-align: center;
`;

export default ConfirmaAgendamiento;
